module.exports = __webpack_public_path__ + "static/media/basic-hand-ranking.929607f1.png";